//export const API_URL = process.env.REACT_APP_API_URL;

// config.js
const host = window.location.hostname;          // si entres per IP pública, això serà la pública; si és LAN, la 192.168.x.x
const proto = window.location.protocol;         // http: o https:
// const port  = process.env.REACT_APP_API_PORT || "8000";



export const API_URL =
  process.env.REACT_APP_API_URL ||
  (proto === "https:"
    ? "https://api.friventca.com"
    : `${proto}//${host}:8000`);